import React, { Fragment, useEffect, useState } from "react";
import { carEVChargeColumns, tripColumns } from "../../../Data/Driver/DriverTrips";
import CommonDataTable from "../../Common/Component/CommonDataTable";
import { showAlert } from "../../../Services/Shared.service";
import { Link } from "react-router-dom";
import moment from "moment";
import CommonToolTip from "../../Common/Component/CommonToolTip";
import StatusIcons from "../../../CommonElements/StatusIcons";
import { getBatteryTransactionsByCarId, getTripsByCarId } from "../../../Services/Car.service";
import { Spinner } from "../../../AbstractElements";
import DataTable from "react-data-table-component";
const CarEVBatteryTransactions = ({ carId }) => {
    const [transactionsData, setTransactionsData] = useState([]);
    const [pagination, setPagination] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(20);
    const [paginationTotalRows, setPaginationTotalRows] = useState(0);
    const [loading, setLoading] = useState(false)

    const onChangePage = (page) => {
        setPagination(page - 1);
    };

    const onChangeRowsPerPage = (currentRowsPerPage) => {
        setRowsPerPage(currentRowsPerPage);
    };


    useEffect(() => {
        fetchEVBatteryTransactions()
    }, []);

    const fetchEVBatteryTransactions = () => {
        setLoading(true)
        const obj = {
            carId: Number(carId),
            size: rowsPerPage,
            page: pagination
        };
        getBatteryTransactionsByCarId(obj)
            .then((result) => {
                setLoading(false)
                if (result.data.list && result.data.list.length > 0) {
                    const processData = result.data.list.map((element, index) => {
                        return {
                            id: element.id
                                ? element.id
                                : "-",
                            lastUpdatedOn: element.lastUpdatedOn
                                ? moment(new Date(element.lastUpdatedOn)).format(
                                    "MMM DD HH:mm"
                                )
                                : "-",
                            estimatedKm: element.estimatedKm ? element.estimatedKm : "-",
                            batteryLevel: element.batteryLevel ? element.batteryLevel : "-",
                        };
                    });
                    setTransactionsData(processData);
                    setPaginationTotalRows(result.data.count);
                }
            })
            .catch((err) => {
                console.log("error", err)
                setLoading(false)
                showAlert("error", "Something went wrong");
            });
    }

    useEffect(() => {
        fetchEVBatteryTransactions();
    }, [pagination, rowsPerPage]);

    return (
        <Fragment>
            <div className="table-responsive driver-trip-table">
                <DataTable
                    columns={carEVChargeColumns}
                    data={transactionsData}
                    center={true}
                    fixedHeader
                    fixedHeaderScrollHeight={'50vh'}
                    paginationPerPage={rowsPerPage}
                    paginationTotalRows={paginationTotalRows}
                    onChangePage={onChangePage}
                    onChangeRowsPerPage={onChangeRowsPerPage}
                    paginationServer
                    pagination
                    progressPending={loading}
                    progressComponent={<div className="loader-box" style={{ height: "50vh" }}>
                        <Spinner attrSpinner={{ className: "loader-3", style: { width: "30px", height: "30px", borderColor: "#39B54A", borderBottomColor: "transparent" } }} />
                    </div>}
                />
            </div>
        </Fragment>
    );
};

export default CarEVBatteryTransactions;
